<!-- Modal Header -->
<div class="modal-header flex items-center gap-3 mb-6">
    <!-- Icon in colored circle (if defined) -->
    @if (descriptionIcon) {
        <div class="icon-container" [style.background-color]="iconBackgroundColor">
            <!-- Icon as string (Material Icon) -->
            @if (isIconString()) {
                <mat-icon [style.color]="iconColor">
                    {{ descriptionIcon }}
                </mat-icon>
            }
            <!-- Icon as TemplateRef -->
            @else if (isIconTemplate()) {
                <ng-container *ngTemplateOutlet="descriptionIcon"></ng-container>
            }
        </div>
    }

    <!-- Modal Title -->
    <h2 class="modal-title" style="color: #111827 !important; display: block !important;">
        {{ title || 'Confirmación' }}
    </h2>
</div>

<!-- Modal Content/Description -->
<mat-dialog-content class="modal-content">
    <p 
        class="text-base leading-relaxed"
        style="color: #374151 !important; display: block !important;"
        [innerHTML]="description || '¿Está seguro de realizar esta acción?'">
    </p>
</mat-dialog-content>

<!-- Modal Actions (Buttons) -->
<mat-dialog-actions class="modal-actions flex justify-end">
    <button 
        mat-button 
        type="button"
        (click)="onCancel()"
        class="cancel-button"
        style="color: #374151 !important; display: inline-flex !important;">
        {{ cancelButtonText || 'Cancelar' }}
    </button>
    
    <button 
        mat-raised-button 
        type="button"
        (click)="onConfirmAction()"
        class="confirm-button"
        [style.background-color]="buttonBackgroundColor"
        [style.color]="buttonTextColor || '#ffffff'"
        style="display: inline-flex !important; background-color: #10b981 !important; color: #ffffff !important;">
        {{ confirmButtonText || 'Confirmar' }}
    </button>
</mat-dialog-actions>

